import { StandardEvents } from '@shopify/events';
import { shippingProgress04 } from './cart-shipping-progress-04.js';

let rulesPromise;
class CartBenefits04 extends HTMLElement {
  connectedCallback() {
    this.querySelector('select[name="country_code"]')?.addEventListener('change', this.changeCountry);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.cartUpdated);
    window.addEventListener('drop-engine:live', this.liveUpdated);
    this.update();
  }
  disconnectedCallback() {
    this.querySelector('select[name="country_code"]')?.removeEventListener('change', this.changeCountry);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.cartUpdated);
    window.removeEventListener('drop-engine:live', this.liveUpdated);
  }
  changeCountry = (event) => event.target.closest('form')?.requestSubmit();
  cartUpdated = (event) => event.promise?.then(() => { if (this.isConnected) this.update(); }).catch(() => {});
  liveUpdated = () => { if (this.isConnected) this.update(); };
  async update() {
    const message = this.querySelector('[data-cart04-shipping-message]');
    const bar = this.querySelector('[data-cart04-shipping-bar]');
    const range = this.querySelector('[data-cart04-shipping-range]');
    const rawCart = this.querySelector('[data-cart04-shipping-cart]');
    if (!message || !bar || !range || !rawCart) return;
    try {
      rulesPromise ||= fetch(this.dataset.rulesUrl).then((response) => { if (!response.ok) throw new Error('Shipping rules unavailable'); return response.json(); });
      const [rules, cart] = [await rulesPromise, JSON.parse(rawCart.textContent)];
      const currency = this.dataset.currency;
      const rate = currency === rules.baseCurrency ? 1 : window.Shopify?.currency?.active === currency ? Number(window.Shopify.currency.rate) : 0;
      const adjustments = await Promise.all(cart.lines.filter((line) => line.dropId).map(async (line) => {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}apps/drop-engine/v1/drops/${encodeURIComponent(line.dropId)}/live`);
        if (!response.ok) throw new Error('Live price unavailable');
        const live = await response.json();
        if (!Number.isFinite(Number(live.priceCents)) || rate <= 0) throw new Error('Live price unavailable');
        return Math.round(Number(live.priceCents) * rate) * line.quantity - line.finalLinePrice;
      }));
      if (!this.isConnected) return;
      const total = cart.total + adjustments.reduce((sum, n) => sum + n, 0);
      const result = shippingProgress04({ rules, lines: cart.lines, country: this.dataset.country, currency, rate, total });
      if (!result) throw new Error('Free shipping unavailable');
      const money = (value) => {
        const parts = new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }
      ).formatToParts(Number(value || 0) / 100);
        const amount = parts.filter(part => part.type !== 'currency' && part.type !== 'literal').map(part => part.value).join('');
        const symbol = parts.find(part => part.type === 'currency')?.value || '€';
        return amount + ' ' + symbol;
      };
      message.textContent = result.unlocked ? this.dataset.unlocked : this.dataset.away.replace('__AMOUNT__', money(result.remaining));
      bar.max = Math.max(1, result.threshold);
      bar.value = result.value;
      bar.hidden = false;
      range.hidden = false;
      this.querySelector('[data-cart04-shipping-zero]').textContent = money(0);
      this.querySelector('[data-cart04-shipping-target]').textContent = money(result.threshold);
    } catch {
      if (!this.isConnected) return;
      message.textContent = this.dataset.checkout;
      bar.hidden = true;
      range.hidden = true;
    }
  }
}
if (!customElements.get('cart-benefits-04')) customElements.define('cart-benefits-04', CartBenefits04);

